// 兼容微信小程序npm构建方式，勿删
